'use client';

import { c as _c } from "react/compiler-runtime";
import ControlBarExitIconButton from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarExitIconButton';
import DefaultAlertDialog from '@/components/DefaultAlertDialog';
import { IFRAME_SEARCH_PARAM_KEYS } from '@/constants/iframe';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useUAContext } from '@/context/UAContext';
import { useEnableFull3d } from '@/hooks/useEnableFull3d';
import { usePathname, useRouter } from '@/i18n/navigation';
import { postMessageToMobileApp } from '@/lib/mobile-app-bridge';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import { useSearchParams } from 'next/navigation';
import { useMemo, useState } from 'react';
type Full3dExitButtonProps = {
  buttonClassName?: string;
  className?: string;
  dialogContainer?: HTMLElement | null;
  dialogPresentation?: 'default' | 'mobile-control-bar';
  iconClassName?: string;
};
export default function Full3dExitButton(t0) {
  const $ = _c(50);
  const {
    buttonClassName,
    className,
    dialogContainer,
    dialogPresentation: t1,
    iconClassName
  } = t0;
  const dialogPresentation = t1 === undefined ? "default" : t1;
  const t = useTranslations();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const {
    isMobileApp
  } = useUAContext();
  const enableFull3d = useEnableFull3d();
  const [dialogOpen, setDialogOpen] = useState(false);
  const isMobileControlBarDialog = dialogPresentation === "mobile-control-bar";
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [portalContainer, setPortalContainer] = useState(null);
  let t2;
  if ($[0] !== isMobileControlBarDialog || $[1] !== searchParams) {
    const params = new URLSearchParams(searchParams.toString());
    params.delete(IFRAME_SEARCH_PARAM_KEYS.FULL3D);
    if (isMobileControlBarDialog) {
      params.delete(IFRAME_SEARCH_PARAM_KEYS.KIDS_MODE);
      params.delete(IFRAME_SEARCH_PARAM_KEYS.VRAM_LIMIT_PASSED);
    }
    t2 = params.toString();
    $[0] = isMobileControlBarDialog;
    $[1] = searchParams;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const query = t2;
  const exitUrl = query ? `${pathname}?${query}` : pathname;
  if (!enableFull3d || roomData.scene_type !== "standalone") {
    return null;
  }
  const t3 = isMobileControlBarDialog ? "contents" : undefined;
  let t4;
  if ($[3] !== t3) {
    t4 = <div ref={setPortalContainer} className={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("leave-room-modal.leave-world.confirm");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setDialogOpen(true);
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== buttonClassName || $[9] !== className || $[10] !== iconClassName || $[11] !== t5) {
    t7 = <ControlBarExitIconButton ariaLabel={t5} buttonClassName={buttonClassName} className={className} iconClassName={iconClassName} onClick={t6} />;
    $[8] = buttonClassName;
    $[9] = className;
    $[10] = iconClassName;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = dialogContainer ?? (isMobileControlBarDialog ? undefined : portalContainer ?? undefined);
  let t9;
  if ($[13] !== t) {
    t9 = t("leave-room-modal.leave-title");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = isMobileControlBarDialog && "text-left text-sm leading-[22px] tracking-[0.2px]";
  let t11;
  if ($[15] !== t10) {
    t11 = cn("body1-omni-styles text-vive-primary-20 text-center md:text-sm md:leading-5.5", t10);
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t) {
    t12 = t("leave-room-modal.leave-world.message");
    $[17] = t;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <p className={t11}>{t12}</p>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t) {
    t14 = t("leave-room-modal.leave-world.cancel");
    $[22] = t;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t) {
    t15 = t("leave-room-modal.leave-world.confirm");
    $[24] = t;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => setDialogOpen(false);
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== exitUrl || $[28] !== isMobileApp || $[29] !== router) {
    t17 = () => {
      setDialogOpen(false);
      if (isMobileApp && "flutterWebview" in window) {
        postMessageToMobileApp({
          feature: "web-back"
        });
        return;
      }
      router.push(exitUrl);
    };
    $[27] = exitUrl;
    $[28] = isMobileApp;
    $[29] = router;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  const t18 = isMobileControlBarDialog && "w-[312px] min-w-[312px] gap-6 p-6 md:max-h-none md:min-h-0 md:max-w-[312px] md:min-w-[312px] md:gap-6 md:p-6 [&>div:first-child]:gap-2";
  let t19;
  if ($[31] !== t18) {
    t19 = cn("md:max-h-fit md:min-h-fit md:max-w-[312px] md:min-w-[312px] md:gap-6 md:p-6 [&>div:first-child]:md:gap-2", t18);
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  const t20 = isMobileControlBarDialog && "text-lg leading-[26px] tracking-[0.1px]";
  let t21;
  if ($[33] !== t20) {
    t21 = cn("md:text-lg md:leading-6.5 font-extrabold", t20);
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  const t22 = isMobileControlBarDialog ? "left" : "center";
  let t23;
  if ($[35] !== dialogOpen || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== t17 || $[40] !== t19 || $[41] !== t21 || $[42] !== t22 || $[43] !== t8 || $[44] !== t9) {
    t23 = <DefaultAlertDialog open={dialogOpen} type="default" container={t8} title={t9} content={t13} cancelText={t14} actionText={t15} onCancel={t16} onAction={t17} className={t19} titleClassName={t21} buttonSize="small2" buttonContainerClassName="md:w-[264px]" contentAlign={t22} />;
    $[35] = dialogOpen;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t17;
    $[40] = t19;
    $[41] = t21;
    $[42] = t22;
    $[43] = t8;
    $[44] = t9;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t23 || $[47] !== t4 || $[48] !== t7) {
    t24 = <>{t4}{t7}{t23}</>;
    $[46] = t23;
    $[47] = t4;
    $[48] = t7;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  return t24;
}